import configs from "../../configs"

export const fieldIsNotEmpty = value => {
  return !value || /^\s*$/.test(value)
}

export const validateEmail = email => {
  const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]{1,32}@[a-zA-Z0-9-]{1,12}(?:\.[a-zA-Z0-9-]{1,10}){1,3}$/

  return re.test(String(email.trim()))
}

export const validatePasswordLength = password => {
  return password.length >= 6
}

export const equalPasswords = (password1, password2) => {
  return password1 === password2
}

export const validateTime = time => {
  const hours = time.split(":")[0]
  const minutes = time.split(":")[1]
  let isInvalid = false

  if (
    hours === undefined ||
    minutes === undefined ||
    +hours > 12 ||
    +hours < 1 ||
    hours.toString().trim().length <= 1 ||
    +minutes > 59 ||
    +minutes < 0 ||
    minutes.toString().trim().length <= 1 ||
    !+hours
  ) {
    isInvalid = true
  }

  return isInvalid
}

export const validateHours = hours => {
  const re = /^\d+(\.\d+)?$/
  let isInvalid = false

  if (!re.test(hours)) {
    isInvalid = true
  }

  return isInvalid
}

export const validatePositivNumber = (numb, floatNumber) => {
  let isInvalid = false
  let floatnumbersAmount

  if (isNaN(numb)) {
    floatnumbersAmount = 0
  } else if (numb.toString().split(".")[1] !== undefined) {
    floatnumbersAmount = numb.toString().split(".")[1].length
  }

  if (
    +numb < 0 ||
    isNaN(numb) ||
    floatnumbersAmount === 0 ||
    floatnumbersAmount > floatNumber
  ) {
    isInvalid = true
  }

  return isInvalid
}

export const validateForm = fields => {
  const invalidFields = {}

  Object.keys(fields).forEach(key => {
    const { name, type, value, required, checked, requiredField } = fields[key]

    if (required) {
      if (type === "checkbox") {
        if (!checked) {
          invalidFields[name] = {
            ...fields[key],
            message: configs.messages.checkbox.isNotChecked
          }
        }
      } else if (name === "password") {
        if (fieldIsNotEmpty(value)) {
          invalidFields[name] = {
            ...fields[key],
            message: configs.messages.password.empty
          }
        } else if (!validatePasswordLength(value)) {
          invalidFields[name] = {
            ...fields[key],
            message: configs.messages.password.length
          }
        }
      } else if (name === "confirm_password" || name === "confirmPassword") {
        if (fieldIsNotEmpty(value)) {
          invalidFields[name] = {
            ...fields[key],
            message: configs.messages.password.empty
          }
        } else if (!equalPasswords(value, fields[requiredField].value)) {
          invalidFields[name] = {
            ...fields[key],
            message: configs.messages.password.isNotEqual
          }
        }
      } else if (type === "email") {
        if (fieldIsNotEmpty(value)) {
          invalidFields[name] = {
            ...fields[key],
            message: configs.messages.email.empty
          }
        } else if (!validateEmail(value)) {
          invalidFields[name] = {
            ...fields[key],
            message: configs.messages.email.incorrect
          }
        }
      } else if (
        name === "lowGuess" ||
        name === "highGuess" ||
        name === "howMuch" ||
        name === "lowPrice" ||
        name === "highPrice"
      ) {
        if (fieldIsNotEmpty(value)) {
          invalidFields[name] = {
            ...fields[key],
            message: "The value is wrong"
          }
        } else if (validatePositivNumber(value, 2)) {
          invalidFields[name] = {
            ...fields[key],
            message: "The value is wrong"
          }
        }
      } else if (name === "goals") {
        let hasInvalidGoal = false

        const newGoals = value.map(goal => {
          const newGoal = goal

          if (fieldIsNotEmpty(goal.goal.value)) {
            newGoal.goal.message = configs.messages.global.empty
            hasInvalidGoal = true
          }

          return newGoal
        })

        if (hasInvalidGoal) {
          invalidFields[name] = {
            ...fields[key],
            value: newGoals
          }
        }
      } else if (name === "daysServiceReview") {
        let hasInvalidField = false

        const newDays = value.map(day => {
          const newDay = day

          if (fieldIsNotEmpty(day.day.value)) {
            newDay.day.message = configs.messages.global.empty
            hasInvalidField = true
          }

          if (fieldIsNotEmpty(day.hours.value)) {
            newDay.hours.message = configs.messages.global.empty
            hasInvalidField = true
          } else if (validateHours(day.hours.value)) {
            newDay.hours.message = "Time is incorrect"
            hasInvalidField = true
          }

          if (fieldIsNotEmpty(day.end.value)) {
            newDay.end.message = configs.messages.global.empty
            hasInvalidField = true
          } else if (validateTime(day.end.value)) {
            newDay.end.message = "Time is incorrect"
            hasInvalidField = true
          }

          if (fieldIsNotEmpty(day.endPeriod.value)) {
            newDay.endPeriod.message = configs.messages.global.empty
            hasInvalidField = true
          }

          if (fieldIsNotEmpty(day.start.value)) {
            newDay.start.message = configs.messages.global.empty
            hasInvalidField = true
          } else if (validateTime(day.start.value)) {
            newDay.start.message = "Time is incorrect"
            hasInvalidField = true
          }

          if (fieldIsNotEmpty(day.startPeriod.value)) {
            newDay.startPeriod.message = configs.messages.global.empty
            hasInvalidField = true
          }

          return newDay
        })

        if (hasInvalidField) {
          invalidFields[name] = {
            ...fields[key],
            value: newDays
          }
        }
      } else if (name === "daysService") {
        let hasInvalidField = false

        const newDays = value.map(day => {
          const newDay = day

          if (
            fieldIsNotEmpty(day.value.num_hours.value) ||
            validateHours(day.value.num_hours.value)
          ) {
            hasInvalidField = true
            newDay.value.num_hours.message = "invalid"
          }

          if (
            fieldIsNotEmpty(day.value.start_time.value) ||
            validateTime(day.value.start_time.value)
          ) {
            hasInvalidField = true
            newDay.value.start_time.message = "invalid"
          }

          if (fieldIsNotEmpty(day.value.start_time_period.value)) {
            hasInvalidField = true
            newDay.value.start_time_period.message = "invalid"
          }

          if (
            fieldIsNotEmpty(day.value.end_time.value) ||
            validateTime(day.value.end_time.value)
          ) {
            hasInvalidField = true
            newDay.value.end_time.message = "invalid"
          }

          if (fieldIsNotEmpty(day.value.end_time_period.value)) {
            hasInvalidField = true
            newDay.value.end_time_period.message = "invalid"
          }

          return newDay
        })

        if (hasInvalidField) {
          invalidFields[name] = {
            ...fields[key],
            value: newDays
          }
        }
      } else if (name === "howOften") {
        if (fieldIsNotEmpty(value) || validatePositivNumber(value, 0)) {
          invalidFields[name] = {
            ...fields[key],
            message: "The value is wrong"
          }
        }
      } else if (fieldIsNotEmpty(value)) {
        invalidFields[name] = {
          ...fields[key],
          message: configs.messages.global.empty
        }
      }
    }
  })

  return invalidFields
}
